import { connect } from 'react-redux';
import { Global } from 'state/Global';
import { graphql } from 'react-apollo';
import { compose } from 'recompose';
import listGroupContactsQuery from 'queries/groupContacts/listGroupContactsQuery.gql';
import _get from 'lodash/get';
import GroupContactsTab from 'components/Users/GroupContacts/GroupContactsTab';
import { actions as ModalActions } from 'actions/modalActions';
import { ModalTypes } from 'constants/modalConstants';

const mapDispatchToProps = (dispatch: Function) => ({
  showEditUserModal: (payload: Object) =>
    dispatch(ModalActions.openModal({ modalType: ModalTypes.EDIT_GROUP_CONTACT, payload })),
});

const mapStateToProps = (state: Global) => ({});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  graphql(listGroupContactsQuery, {
    options: { variables: { sort: { propertyName: 'displayName' } } },
    // tslint:disable-next-line
    props: ({ data, ownProps }: any) => {
      return {
        ...ownProps,
        data,
        fetchMoreRows: () => {
          // If directory list isn't set our initial load hasn't finished yet, so we
          // can't fetch more. We also bail if there are no more records to load.
          if (
            !data ||
            !data.directoryList ||
            !data.directoryList.hasMoreRecords
          ) {
            return Promise.resolve({});
          }

          return data.fetchMore({
            variables: { cursor: data.directoryList.cursor }, // Pass in the previous cursor to our query.
            // tslint:disable-next-line
            updateQuery: (prev: any, { fetchMoreResult }: any) => {
              // Merge our new results into previous cached results.
              const previousDirectoryList = _get(prev, 'directoryList', {});
              const fetchMoreResultDirectoryList = _get(fetchMoreResult, 'directoryList', {});
              return {
                ...prev,
                directoryList: {
                  ...previousDirectoryList,
                  hasMoreRecords: _get(fetchMoreResultDirectoryList, 'hasMoreRecords', true),
                  cursor: _get(fetchMoreResultDirectoryList, 'cursor', {}),
                  records: [
                    ..._get(previousDirectoryList, 'records', []),
                    ..._get(fetchMoreResultDirectoryList, 'records', []),
                  ],
                },
              };
            },
          });
        },
      };
    },
  }),
)(GroupContactsTab);
